import { Box } from 'designSystem/components/Box'
import { useSidebar } from 'designSystem/components/Sidebar'
import { SidebarCollapseToggle } from 'designSystem/components/SidebarCollapseToggle'
import { useIsMobile } from 'designSystem/hooks/useMobile'

import {
  SidebarFlavorSubTextLine,
  SidebarFlavorText,
  SidebarFlavorTextLine,
} from './embeddedSidebarStyles'

export function EmbeddedSidebarFooterBar({
  chatLayout,
  showAIRFooter,
}: {
  chatLayout: boolean
  showAIRFooter: boolean
}) {
  const { state } = useSidebar()
  const isMobile = useIsMobile()
  const isCollapsed = state === 'collapsed'

  return (
    <Box
      display='flex'
      align='center'
      justify={!chatLayout && isCollapsed ? 'center' : undefined}
      paddingTop={chatLayout ? 'none' : 'sm'}>
      {chatLayout || !isCollapsed ? (
        <SidebarFlavorText $chatLayout={chatLayout} aria-hidden='true'>
          <SidebarFlavorTextLine>Gecko Robotics</SidebarFlavorTextLine>
          {showAIRFooter ? (
            <SidebarFlavorSubTextLine>
              AIR · AI + Robotics
            </SidebarFlavorSubTextLine>
          ) : null}
        </SidebarFlavorText>
      ) : null}
      {!isMobile ? <SidebarCollapseToggle /> : null}
    </Box>
  )
}
